import Request from "../../utilities/Request.jsx";
import { sessionExpired, setPlayer } from "./dashboard.js";

export const SHOW_LOGIN_POPUP_BEGIN = 'SHOW_LOGIN_POPUP_BEGIN';
export const SHOW_LOGIN_POPUP_END = 'SHOW_LOGIN_POPUP_END';

export const showLoginPopup = () => (dispatch, getState) => {
	dispatch({
		type: SHOW_LOGIN_POPUP_BEGIN
	});
};
export const closeLoginPopup = () => (dispatch, getState) => {
	dispatch({
		type: SHOW_LOGIN_POPUP_END
	});
};

export const getLogin = () => (dispatch) => {
	return Request.apiv1GetFromCache('player')
		.then((response) => {
			console.log('SETTING PLAYER FROM APP ROUTER', response);
			if(response.player) {
				dispatch(setPlayer(response.player));
				return response.player;
			}
		})
		.catch((response) => {
			console.log('Cache Retrieve Player Error?', response);
		})
		.then((player) => {
			console.log('Refreshing player data the regular way (May grab stale data from sw cache, which will then update it for next load)');
			return Request.apiv1Get('player')
				.then((response) => {
					dispatch(setPlayer(response.player));
					console.log('Successfully updated user data for next time', response);
				})
				.catch((error) => {
					if(error.status === 401) {
						// Not logout(): that deletes the changes made offline, which wait for the next sign-in.
						console.error('Got invalid auth!, initiating logout');
						dispatch(sessionExpired());
						return;
					}
					console.error('fail retrieving updated player data, possibly offline or a temporary error');
					console.error(error);
				});
		});
};